import { render, staticRenderFns } from "./table.vue?vue&type=template&id=80ec8bdc&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"
import style0 from "./table.vue?vue&type=style&index=0&id=80ec8bdc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ec8bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80ec8bdc')) {
      api.createRecord('80ec8bdc', component.options)
    } else {
      api.reload('80ec8bdc', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=80ec8bdc&scoped=true", function () {
      api.rerender('80ec8bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/table.vue"
export default component.exports